module.exports = __webpack_public_path__ + "static/media/milkovi-kYlYwQze5vI-unsplash_compressed.4ae2b200.jpg";